import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { cx } from "../lib/cx";
import { useI18n, type I18nKey } from "../i18n";
import type { PlanId } from "../lib/plans";
import { statusKey, statusTone } from "../lib/jobStatus";
import type { JobStatus } from "@workcost/shared";

export type BadgeTone = "info" | "success" | "warning" | "danger" | "primary" | "neutral";

/** Badge มีจุดสีหน้าข้อความ สถานะต้องมีข้อความกำกับเสมอ ไม่สื่อด้วยสีอย่างเดียว */
export function Badge({ tone = "neutral", dot = true, children }: { tone?: BadgeTone; dot?: boolean; children: ReactNode }) {
  return <span className={cx("badge", tone !== "neutral" && `badge-${tone}`, !dot && "no-dot")}>{children}</span>;
}

export function PlanBadge({ plan }: { plan: PlanId }) {
  const { t } = useI18n();
  return <span className={cx("plan-badge", `plan-${plan}`)}>{t(`plan.${plan}` as I18nKey)}</span>;
}

const SOURCE: Record<"ai" | "ref" | "user", { icon: "sparkles" | "file" | "pen"; key: I18nKey }> = {
  ai: { icon: "sparkles", key: "src.ai" },
  ref: { icon: "file", key: "src.ref" },
  user: { icon: "pen", key: "src.user" },
};

export function SourceTag({ source, compact }: { source: "ai" | "ref" | "user"; compact?: boolean }) {
  const { t } = useI18n();
  const s = SOURCE[source];
  return (
    <span className={cx("src", `src-${source}`)}>
      <Icon name={s.icon} />
      {compact && source === "ai" ? "AI" : t(s.key)}
    </span>
  );
}

/** Badge สถานะงาน (สีตามตารางใน components.md, ข้อความมาจาก i18n เสมอ) */
export function StatusBadge({ status }: { status: JobStatus }) {
  const { t } = useI18n();
  return <Badge tone={statusTone(status)}>{t(statusKey(status))}</Badge>;
}
